const sensorSlot = [
  { type: 'maxlength', message: 'Sensor Slot name must be at most of 32 characters' }
]

export default { sensorSlot }
